import React, { useCallback, useState } from 'react';
import DatePicker from 'react-datepicker';
import ptBR from 'date-fns/locale/pt-BR';
import { BiCalendar } from 'react-icons/bi';
import Input from '~/components/Input';
import { Container } from './styles';

interface InputDateProps {
  name?: string;
  onChange?(date: Date | [Date, Date] | null): void;
  selected?: Date | null;
  className?: string;
  dateFormat?: string | string[];
  isError?: boolean;
}

const InputDate: React.FC<InputDateProps> = ({
  name,
  onChange,
  selected,
  className,
  dateFormat,
  isError,
}) => {
  const [value, setValue] = useState('');

  const handleChange = useCallback(
    (e) => {
      setValue(e);
      if (onChange) {
        onChange(e);
      }
    },
    [onChange]
  );

  return (
    <>
      <Container className="d-flex align-items-center py-1 px-3">
        <DatePicker
          onChange={handleChange}
          selected={selected}
          className={`${className} ${isError ? 'error-input' : ''}`}
          dateFormat={dateFormat || 'dd/MM/yyyy'}
          locale={ptBR}
          showMonthDropdown
          showYearDropdown
          dropdownMode="select"
        />
        <BiCalendar size={14} color="#5D5D5D" />
      </Container>
      {name && (
        <Input
          type="hidden"
          name={name}
          className="d-none"
          value={selected?.toISOString()}
        />
      )}
    </>
  );
};

export default InputDate;
